var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudioActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 31,
    viewBox: "0 0 44 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.742857 0H43.1429H43.8857V0.742857V25.4571V26.2H43.1429H27.7036V29.1607H30.3036V31H13.5286V29.1607H16.1286V26.2H0.742857H0V25.4571V0.742857V0H0.742857ZM42.4036 1.48214H1.48214V24.7143H42.4L42.4036 1.48214Z",
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudioActiveIcon);
export default __webpack_public_path__ + "static/media/studioActiveIcon.ff8466e08f0cf496f1333986107a563d.svg";
export { ForwardRef as ReactComponent };